export default "__VITE_ASSET__vxonL4Q2__"